module.exports = __webpack_public_path__ + "img/hr-distractor-robot-mask.5baae083.png";